import React from 'react';
import { QRCodeCanvas } from 'qrcode.react';

const tierStyles = {
  Silver: {
    bg: 'bg-gradient-to-br from-[#e0e0f0] via-[#e0e0fd] via-[#e0e0f0] via-[#ffe0c0] to-blue-400',
    border: 'border-white',
    text: 'text-gray-800 drop-shadow-[1px_1px_0_rgba(255,255,255,0.7)]',
    symbol: '🥈',
    textSections: {
      name: 'text-gray-800',
      roles: 'text-gray-700',
      number: 'text-black',
      meta: 'text-gray-600',
      status: 'text-black'
    }
  },
  Gold: {
    bg: 'bg-gradient-to-br from-yellow-500 via-yellow-400 via-yellow-300 via-yellow-200 to-purple-300',
    border: 'border-white',
    text: 'text-yellow-900 drop-shadow-[1px_1px_0_rgba(0,0,0,0.6)]',
    symbol: '🥇',
    textSections: {
      name: 'text-black',
      roles: 'text-black',
      number: 'text-black',
      meta: 'text-black',
      status: 'text-black'
    }
  },
  Premium: {
    bg: 'bg-gradient-to-br from-red-600 via-red-400  via-red-600  via-red-700 to-blue-300',
    border: 'border-white',
    text: 'text-white drop-shadow-[1px_1px_0_rgba(0,0,0,0.6)]',
    symbol: '👑',
    textSections: {
      name: 'text-white',
      roles: 'text-white',
      number: 'text-white',
      meta: 'text-white',
      status: 'text-black'
    }
  },
  Royal: {
    bg: 'bg-gradient-to-br from-purple-900 via-purple-700 via-purple-500 via-purple-300 to-blue-200',
    border: 'border-white',
    text: 'text-white',
    symbol: '💎',
    textSections: {
      name: 'text-white',
      roles: 'text-white',
      number: 'text-white',
      meta: 'text-white',
      status: 'text-white'
    }
  }
};

export default function SmartCardPersonal({
  name,
  role1,
  role2,
  cardNumber,
  tier = 'Silver',
  mode = 'Personal',
  isVerified = false,
  isTrusted = false,
  reviewCount = 1,
  qrCodeUrl,
  photoUrl,
  joinedOn,
  cardValidity,
  businessCode,
  showLogo = false,
  country,
  status,
  badge,
  ratingstar
}) {
  const styles = tierStyles[tier] || tierStyles.Silver;

  return (
    <div
      className={`w-96 h-56 rounded-2xl shadow-xl p-3 border-2 ${styles.bg} ${styles.border} text-sm relative overflow-hidden`}
    >
      {/* Card Title */}
      <div className={`font-bold uppercase text-lg flex items-center gap-2 ${styles.text}`}>
        <span>{tier} {mode} Card</span>
      </div>

      {/* User Info */}
      <div className="mt-2">
        <div className={`text-xl font-bold ${styles.textSections.name}`}>{name}</div>

        <div className={`mt-1 ${styles.textSections.roles}`}>
          {role1}{role2 ? ` | ${role2}` : ''}
        </div>

        <div className={`mt-3 font-mono tracking-widest text-2xl font-bold drop-shadow-[2px_2px_0_rgba(0,0,0,0.5)] ${styles.textSections.number}`}>
          {cardNumber}
        </div>

        <div className={`mt-2 text-xs space-y-1 ${styles.textSections.meta}`}>
          <div><strong>Valid:</strong> {cardValidity}</div>
         {/* <div><strong>Code:</strong> {businessCode}</div>*/}
        </div>

        <div className="flex items-center gap-2 text-sm mt-1">
          <div className={`${styles.textSections.status}`}>
            <span>Status: </span>
            <span className="font-semibold">{status}</span>
          </div>
          <div className="text-green-400 text-base leading-none">
            ★★★★★
          </div>
        </div>
      </div>

      {/* Bottom Right Content */}
      <div className="absolute bottom-4 right-4 flex flex-col items-end gap-1">
        {photoUrl && (
          <img
            src={photoUrl}
            alt="User"
            className={`w-20 h-20 rounded-2xl border-2 object-cover shadow-md mb-10 z-10
              ${
                tier === 'Gold'
                  ? 'border-yellow-500'
                  : tier === 'Royal'
                  ? 'border-purple-300'
                  : tier === 'Premium'
                  ? 'border-red-700'
                  : 'border-gray-200'
              }
            `}
          />
        )}

        {(qrCodeUrl || isVerified) && (
          <div className="flex items-center gap-4 -mb-1 border-yellow-600 px-3 py-1 rounded-lg shadow-sm text-green-800 font-semibold text-xs z-0">
            {qrCodeUrl && <QRCodeCanvas value={qrCodeUrl} size={40} />}
            {showLogo && (
              <div className="flex justify-center items-center p-1 shadow-sm">
                <img
                  src="/assets/images/m2t-logo.png"
                  alt="M2T"
                  className="w-10 h-10 bg-white rounded-lg"
                />
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
}
